import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useGetDossierData } from '../../../../resources/dossier/queries';
import { useIsFirstAgentMessage } from '../../../../resources/discussion/queries';
import { Message } from '../../../../resources/discussion/types';
import { DossierId } from '../../../../resources/dossier/types';

/**
 * Détermine si un message est le premier message AT1 auto d'un dossier AT1 auto.
 *
 * Conditions:
 * 1. Message envoyé par un agent
 * 2. Dossier flagué isAt1Auto
 * 3. L'AT1 Auto n'a pas été annulé
 * 4. Premier message de l'agent dans la discussion
 */
export const useIsAt1AutoMessage = (message: Message): boolean => {
    const { dossierId } = useParams() as { dossierId: DossierId };
    const { dossier } = useGetDossierData(dossierId) || {};
    const isFirstAgentMessage = useIsFirstAgentMessage(dossierId, message.id);

    return useMemo(() => {
        if (!message.isFromAgent) return false;
        if (!dossier?.isAt1Auto) return false;
        if (dossier?.isAt1AutoCanceled) return false;
        if (!isFirstAgentMessage) return false;

        return true;
    }, [message.isFromAgent, dossier?.isAt1Auto, dossier?.isAt1AutoCanceled, isFirstAgentMessage]);
};
